import { Component, Input, OnDestroy } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { Observable, Subject, takeUntil } from 'rxjs';
import { selectHelpers } from 'src/app/core/store/helpers/selector/helpers.selectors';
import { Store } from '@ngrx/store';
import { appState } from 'src/app';

@Component({
  selector: 'app-accordion-btn-inner-content',
  templateUrl: './accordion-btn-inner-content.component.html',
  styleUrls: ['./accordion-btn-inner-content.component.scss'],
  standalone: true,
  imports: [TranslocoModule, NgIf],
})
export class AccordionBtnInnerContentComponent implements OnDestroy {
  @Input()
  name: string = '';
  @Input()
  isInner: boolean = false;
  @Input()
  index!: number;
  @Input() white: boolean = false;
  @Input() isAdvent: boolean = false;
  isMobile: boolean = true;
  helpers$: Observable<any> = this.store.select(selectHelpers);
  unsubus$: Subject<boolean> = new Subject();

  constructor(private store: Store<appState>) {
    this.helpers$.pipe(takeUntil(this.unsubus$)).subscribe((res) => {
      this.isMobile = res?.isMobile;
    });
  }
  closed: boolean = false;

  toggleAccordion() {
    this.closed = !this.closed;
  }

  ngOnDestroy(): void {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
}
